import { updateFolderViewState } from '../actions/folderViewStatesActions';
import setFolderSortBy from '../actions/setFolderSortBy';
import getFolderViewStateFromId from '../selectors/getFolderViewStateFromId';
import { orchestrator } from 'satcheljs';

export default orchestrator(setFolderSortBy, actionMessage => {
    const { folderId, sortColumn, sortDirection } = actionMessage;
    const localViewState = getFolderViewStateFromId(folderId);
    localViewState.sortColumn = sortColumn;
    localViewState.sortOrder = sortDirection;
    updateFolderViewState(folderId);
});
